// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3A63u","content":"styles_content__1UPYo"};